<template>
  <div>
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item">
        <router-link to="/base-data/units">Egységek</router-link>
      </li>
      <li class="breadcrumb-item active">{{ unit.name }}</li>
    </ol>
    <h1 class="page-header">Egység szerkesztése</h1>
    <Loading v-if="unit === false" title="Egység betöltése"></Loading>
    <NoRecords
      v-if="unit.notfound"
      main_icon="fas fa-user-lock"
      value="false"
      title="Nem található a egység"
      subtitle="Menjen vissza a egységekhez!"
    ></NoRecords>
    <div class="row" v-if="unit !== false && !unit.notfound">
      <div class="col-md-6">
        <panel title="Adatok">
          <form @submit.prevent="updateUnit()">
            <div class="form-group">
              <label class="form-label" for="number">Szám</label>
              <input
                type="number"
                v-model="unit.number"
                required
                class="form-control"
              />
              <div class="bg-danger" v-if="errors.number">
                {{ error.number[0] }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label" for="name">Megnevezés</label>
              <input
                type="text"
                v-model="unit.name"
                required
                class="form-control"
              />
              <div class="bg-danger" v-if="errors.name">
                {{ error.name[0] }}
              </div>
            </div>
            <div class="form-group mt-2">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="unit.is_radiating"
                />
                <label class="form-check-label" for="is_radiating"
                  >Sugárvédelem szükséges!</label
                >
              </div>
            </div>
            <div class="text-end mt-2">
              <button class="btn btn-primary">
                <i class="fa fa-save"></i> Mentés
              </button>
            </div>
          </form>
        </panel>
      </div>
      <div class="col-md-6">
        <panel title="Lakatok">
          <Loading
            v-if="locks === false || positions == false"
            title="Lakatok betöltése"
          ></Loading>
          <div v-else>
            <form @submit.prevent="addLock()">
              <div class="row">
                <div class="form-group col-4">
                  <label class="form-label">Lakat:</label>
                  <v-select
                    v-if="locks"
                    v-model="lockadd_object.lock_id"
                    :options="
                      locks.filter(
                        (l) =>
                          l.color == 2 &&
                          !unit.locks.map((lock) => lock.id).includes(l.id)
                      )
                    "
                    :reduce="(option) => option.id"
                    label="name"
                  >
                    <template #option="{ name }">
                      <i class="fa fa-lock text-warning"></i> {{ name }}
                    </template>
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!lockadd_object.lock_id"
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="!lockadd_object.lock_id ? 'Válassz' : ''"
                      />
                    </template>
                  </v-select>
                </div>
                <div class="form-group col-4">
                  <label class="form-label">Pozíció:</label>
                  <v-select
                    v-if="positions"
                    v-model="lockadd_object.position_id"
                    :options="
                      positions.filter(
                        (p) =>
                          !unit.locks
                            .map((l) => l.pivot.position_id)
                            .includes(p.id)
                      )
                    "
                    :reduce="(option) => option.id"
                    label="full_name"
                  >
                    <template #option="{ name, position_id }">
                      {{ position_id }} - {{ name }}
                    </template>
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!lockadd_object.position_id"
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="
                          !lockadd_object.position_id ? 'Válassz' : ''
                        "
                      />
                    </template>
                  </v-select>
                </div>
                <div class="from-group col-2">
                  <label class="form-label">Szám:</label>
                  <input
                    type="number"
                    class="form-control"
                    required
                    v-model="lockadd_object.number"
                  />
                </div>
                <div class="form-group col-2">
                  <button type="submit" class="btn btn-success mt-4">
                    <i class="fa fa-plus"></i> Hozzáadás
                  </button>
                </div>
              </div>
            </form>
            <div class="table-responsive" v-if="unit.locks.length != 0">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Lakat</th>
                    <th>Pozíció</th>
                    <th>Szám</th>
                    <th class="text-end">Műveletek</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lock, id) in unit.locks" :key="id">
                    <td><i class="fa fa-lock text-warning fa-2x"></i></td>
                    <td>{{ lock.name }}</td>
                    <td>
                      {{
                        positions[
                          positions
                            .map((p) => p.id)
                            .indexOf(lock.pivot.position_id)
                        ].full_name
                      }}
                    </td>
                    <td>{{ lock.pivot.number }}</td>
                    <td class="text-end">
                      <button
                        class="btn btn-danger"
                        @click="deleteLock(lock.id)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Box from "../../apis/Box";
import Lock from "../../apis/Lock";
import Confirmation from "../../apis/Confirmation";

export default {
  components: {
    Loading,
    NoRecords,
  },
  data() {
    return {
      unit: false,
      errors: [],
      locks: false,
      lockadd_object: {},
    };
  },
  computed: {
    positions() {
      return this.$store.state.positions;
    },
  },
  created() {
    Lock.index().then((response) => {
      this.locks = response.data;
    });
    this.positions.forEach((p) => {
      this.$set(p, "full_name", p.position_id + " - " + p.name);
    });
    Box.show(this.$route.params.id)
      .then((response) => {
        this.$set(this, "unit", response.data);
      })
      .catch(() => {
        this.$set(this, "unit", { name: "ismeretlen", notfound: true });
      });
  },
  methods: {
    deleteLock(lock_id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          //console.log(lock_id);
          Box.deleteLock(this.$route.params.id, { lock_id: lock_id })
            .then(() => {
              this.unit.locks.splice(
                this.unit.locks.map((l) => l.lock_id).indexOf(lock_id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    addLock() {
      Box.addLock(this.$route.params.id, this.lockadd_object).then(() => {
        this.lockadd_object.name =
          this.locks[
            this.locks.map((l) => l.id).indexOf(this.lockadd_object.lock_id)
          ].name;
        this.lockadd_object.id = this.lockadd_object.lock_id;
        this.lockadd_object.pivot = {
          position_id: this.lockadd_object.position_id,
          number: this.lockadd_object.number,
        };
        this.unit.locks.push(this.lockadd_object);
        this.lockadd_object = {};
      });
    },
    updateUnit() {
      Box.update(this.$route.params.id, this.unit).catch((error) => {
        if (error.response.data.errors) {
          this.errors = error.response.data.errors;
        }
      });
    },
  },
};
</script>

<style></style>
